import request from '@/utils/request'
import JsonBigint from 'json-bigint'

const api = {
  DownPageRecord: 'game-api/index/downPageRecord',
  PunishList: 'web-api/index/punishList',
  GuideInfo: 'web-api/index/platformGuideInfo',
  NetNoticeInfo: 'web-api/index/netNoticeInfo',
  NetNoticeList: '/web-api/index/netNoticeList',
  CollectInfo: '/web-api/index/collectInfo'
}


export function punishList () {
  return request({
    url: api.PunishList,
    method: 'get'
  })
}

export function guideInfo (id) {
  return request({
    url: api.GuideInfo + '/' + id,
    method: 'get'
  })
}

export function collectInfo (param) {
  return request({
    url: api.CollectInfo,
    method: 'get',
    params: param
  })
}

export function netNoticeInfo (id) {
  return request({
    url: api.NetNoticeInfo + '/' + id,
    method: 'get'
  })
}

export function netNoticeList (param) {
  return request({
    url: api.NetNoticeList,
    method: 'get',
    params: param,
    transformResponse: [data => {
      data = JsonBigint.parse(data)
      data.data.list.filter(item => {
        item.id = item.id.toString()
        return item
      })
      return data
    }]
  })
}
